
import { z } from "zod";

export const contactSchema = z.object({
  firstName: z.string().min(2, "Le prénom doit contenir au moins 2 caractères"),
  lastName: z.string().min(2, "Le nom doit contenir au moins 2 caractères"),
  email: z.string().email("Email invalide"),
  company: z.string().min(2, "Le nom de l'entreprise doit contenir au moins 2 caractères"),
  message: z.string().min(10, "Le message doit contenir au moins 10 caractères"),
});

export const demoSchema = z.object({
  firstName: z.string().min(2, "Le prénom doit contenir au moins 2 caractères"),
  lastName: z.string().min(2, "Le nom doit contenir au moins 2 caractères"),
  email: z.string().email("Email invalide"),
  company: z.string().min(2, "Le nom de l'entreprise doit contenir au moins 2 caractères"),
  jobTitle: z.string().min(2, "Le poste doit contenir au moins 2 caractères"),
  teamSize: z.string().min(1, "Veuillez sélectionner la taille de votre équipe"),
  preferredDate: z.string().min(1, "Veuillez indiquer vos disponibilités"),
  interest: z.string().min(1, "Veuillez sélectionner votre sujet d'intérêt"),
});

export type ContactFormData = z.infer<typeof contactSchema>;
export type DemoFormData = z.infer<typeof demoSchema>;
